import { action } from 'satcheljs';
import type { ClientItemId } from 'owa-client-ids';

export const clearAttachmentFiles = action('clearAttachmentFiles');
export const clearLinkFiles = action('clearLinkFiles');

export const onDraftEventCreated = action(
    'onDraftEventCreated ',
    (itemId: ClientItemId, formId: string) => ({
        itemId,
        formId,
    })
);

export const addLinkFile = action('addLinkFile ', (linkId: string, providerId: string) => ({
    linkId,
    providerId,
}));
